module.exports = __webpack_public_path__ + "img/Adobe-logo.1c7f718e.png";